import AiContextList from './agenteia-list.vue';
import AiContextForm from './agenteia-form.vue';
import AiAgentDocumentsPage from './agenteia-documentos.vue';
import RoutesUtils from '../../js/RoutesUtils.js';
import { AI_CONTEXT_CONFIG } from './config.js';

const routes = [];

routes.push({
  path: '/agenteia/documentos/',
  beforeEnter: RoutesUtils.checkAuthPage,
  async: RoutesUtils.checkPermission('ai/agent/documents', [], AiAgentDocumentsPage),
  keepAlive: true
});

Object.values(AI_CONTEXT_CONFIG).forEach((config) => {
  routes.push({
    path: config.routeBase,
    beforeEnter: RoutesUtils.checkAuthPage,
    async: RoutesUtils.checkPermission(config.permissionBase, [], AiContextList, { contextType: config.key }),
    keepAlive: true
  });
  routes.push({
    path: `${config.routeBase}new/`,
    beforeEnter: RoutesUtils.checkAuthPage,
    async: RoutesUtils.checkPermission(`${config.permissionBase}/new`, [], AiContextForm, { contextType: config.key })
  });
  routes.push({
    path: `${config.routeBase}edit/:id/`,
    beforeEnter: RoutesUtils.checkAuthPage,
    async: RoutesUtils.checkPermission(`${config.permissionBase}/edit`, [], AiContextForm, { contextType: config.key })
  });
  routes.push({
    path: `${config.routeBase}view/:id/`,
    beforeEnter: RoutesUtils.checkAuthPage,
    async: RoutesUtils.checkPermission(`${config.permissionBase}/view`, [], AiContextForm, { contextType: config.key, editable: false })
  });
});

export default routes;
